import React, { useEffect, useState } from "react";
import { TbDownload, TbLogs } from "react-icons/tb";
import LineChartStatus from "../../Components/Charts/LineChart";
import { IoChevronDown, IoChevronUp, IoReload } from "react-icons/io5";
import FormatDateTime from "../../Functions/FormatDate";
import SingleLoaderItem from "../../Loaders/SingleLoaderItem";
import { Dropdown } from "react-bootstrap";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import BarChartTime from "../../Components/Charts/BarChart";
import { useLanguage } from "../../Translations/LenguageContext";

const AbilitiesAnalytics = ({
    data,
    loading
}) => {
    const {t} = useLanguage()
    const [openLog, setOpenLog] = useState("")
    const [selectedItem, setSelectedItem] = useState({})
    const [selectedItemId, setSelectedItemId] = useState(null)

    useEffect(() => {
        if (data) {
            setSelectedItem(data[0])
            setSelectedItemId(data[0]?.id)
        }
    }, [data])

    return (
        <div className="analytics_cont_body_inner">
            <div className="analytics_cont_body_inner_chart_cont">
                <div className="chart_header">
                    <p className="chart_header_title fade-in">{t.analytics.total_requests}</p>
                    {data.length > 0 && (
                        <div className="chart_header_last">
                            <Dropdown autoClose={"outside"}>
                                <Dropdown.Toggle
                                    as="div"
                                    className="analytics_cont_header_title_btn fade-in"
                                >
                                    {data
                                        .filter(singleItem => selectedItemId === singleItem.id)
                                        .map(singleItem => singleItem.name)
                                        .join(", ") || "Select organization"
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="custom_dropdown_menu">
                                    <div className="dropdown_container fade-in">
                                        {data.map((singleItem) => (
                                            <button
                                                key={singleItem.id}
                                                onClick={() => { setSelectedItemId(singleItem.id); setSelectedItem(singleItem) }}
                                                className={`settings_link ${selectedItemId == singleItem.id && "settings_link_selected"}`}
                                            >
                                                {singleItem.name}
                                            </button>
                                        ))}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    )}
                </div>

                <div className="chart_cont fade-in">
                    <BarChartTime data={selectedItem ? [selectedItem] : []} loading={loading}/>
                </div>
            </div>
        </div>
    );
};

export default AbilitiesAnalytics;